<template>
  <div class="app-content">
    <div class="layout-pods orders">
      <header class="layout-pods-header pg-header">
        <div></div>
      </header>
      <div class="">
        <div class="row">
          <div class="col-12">
            <template>
              <div>
                <div class="row">
                  <div class="col-12 col-md-12 col-lg-9 filter-elements">
                    <div class="col-12 col-md-4 col-lg-3 mr-2">
                      <client-list-dropdown
                        :value="selectedClient"
                        @on-client-selected="handleClientSelected"
                        @on-client-removed="handleClientRemoved"
                      />
                    </div>

                    <div class="col-12 col-md-4 col-lg-3 mr-2">
                      <div class="date-time-picker-container inline">
                        <DateTimePicker
                          color="#13a3eb"
                          class="mr-sm-2"
                          noLabel
                          formatted="DD MMM YYYY"
                          format="YYYY-MM-DD"
                          v-model="selectedDates"
                          autoClose
                          input-size="sm"
                          range
                          noClearButton
                          noButton
                          :no-value-to-custom-elem="false"
                          only-date
                          :disabled="noClientSelected"
                        >
                        </DateTimePicker>
                      </div>
                    </div>

                    <div class="col-12 col-md-4 col-lg-3 mr-2">
                      <form id="order-search" class="search-form order-search">
                        <input
                          class="form-control"
                          type="search"
                          placeholder="Search"
                          aria-label="Search"
                          v-model="searchText"
                          :disabled="noClientSelected"
                        />
                      </form>
                    </div>
                  </div>
                  <div
                    class="col-12 col-md-12 col-lg-3 justify-content-end align-items-center filter-buttons"
                  >
                    <button
                      @click="clearFilters"
                      class="btn btn-primary mr-3"
                      :disabled="noClientSelected"
                    >
                      Clear Filters
                    </button>
                    <button
                      class="btn btn-quaternary mr-3"
                      v-if="$isAllowed('exportCsv')"
                      @click="exportCSV"
                      :disabled="noClientSelected"
                    >
                      EXPORT
                    </button>
                  </div>
                </div>

                <p class="text-right bold">Total Orders: {{ totalRows }}</p>

                <div v-if="noClientSelected">
                  <app-action-needed
                    title="No client selected"
                    description="Please select a client to get started"
                  />
                </div>
                <div v-if="noResults">
                  <app-action-needed
                    title="No orders found"
                    description="We cant find any orders that match the given filter."
                  />
                </div>
                <section class="notifications-list">
                  <template>
                    <ol v-if="orders.length > 0">
                      <li>
                        <div class="container-fluid">
                          <div class="row">
                            <div class="col-2">
                              <b>Office</b>
                            </div>
                            <div class="col-5">
                              <b>Order</b>
                            </div>
                            <div class="col-1">
                              <b>Type</b>
                            </div>
                            <div class="col-1">
                              <b>Suburb</b>
                            </div>
                            <div class="col-1">
                              <b>Start Date</b>
                            </div>
                            <div class="col-1">
                              <b>End Date</b>
                            </div>
                            <div class="col-1">
                              <b>Booked Date</b>
                            </div>
                          </div>
                        </div>
                      </li>
                      <li
                        v-for="(order, index) in orders"
                        :key="`${order.id}-${index}`"
                      >
                        <div class="container-fluid">
                          <div class="row">
                            <div class="col-2">
                              <b>{{ order.agency.displayName }}</b>
                            </div>
                            <div class="col-5">
                              <template v-if="$isAllowed('viewCampaigns')">
                                <a
                                  href="#"
                                  target="_blank"
                                  class="btn-link"
                                  @click.prevent="goToDashboard(order)"
                                >
                                  {{ order.campaign.displayName }}
                                  <span v-if="$isAllowed('viewPrices')">
                                    {{ order.packagePrice | formatCurrency }}
                                    <template v-if="hasGst(order)"
                                      >incl. GST</template
                                    >
                                    <template v-else
                                      >excl. GST</template
                                    >
                                  </span>
                                </a>
                              </template>
                              <template v-else>
                                {{ order.campaign.displayName }}
                                <span v-if="$isAllowed('viewPrices')">
                                  {{ order.packagePrice | formatCurrency }}
                                  <template v-if="hasGst(order)"
                                    >incl. GST</template
                                  >
                                  <template v-else
                                    >excl. GST</template
                                  >
                                </span>
                              </template>
                              <span
                                v-if="order.status"
                                :class="{
                                  'badge badge-in-progress':
                                    order.status === 'In Progress',
                                  'badge badge-finished':
                                    order.status === 'Finished',
                                  'badge badge-booked':
                                    order.status === 'Booked',
                                  'badge badge-cancelled':
                                    order.status === 'Cancelled',
                                  'badge badge-stopped':
                                    order.status === 'Stopped',
                                  'badge badge-draft': order.status === 'Draft',
                                }"
                                >{{ order.status }}</span
                              >
                            </div>
                            <div class="col-1">
                              <template
                                v-if="order.campaignType == 'property extend'"
                              >
                                Property
                              </template>
                              <template v-else>
                                {{
                                  order.campaignType
                                    | capitalizeTheFirstLetterOfEachWord
                                }}
                              </template>
                            </div>
                            <div class="col-1">
                              <template
                                v-if="
                                  order.campaignType == 'property' ||
                                    order.campaignType == 'property extend'
                                "
                              >
                                {{ order.campaign.property.suburb }}
                              </template>
                            </div>
                            <div class="col-1">
                              <!-- Start Date -->
                              {{
                                order.campaign.startDate
                                  | formatDate('DD MMM YYYY')
                              }}
                            </div>
                            <div class="col-1">
                              <!-- End Date -->
                              {{ order.campaign.endDate }}
                            </div>
                            <div class="col-1">
                              {{ order.createdAt | formatDate('DD MMM YYYY') }}
                            </div>
                          </div>
                        </div>
                      </li>
                    </ol>
                    <div v-else>
                      <!--                                        <p>No orders</p>-->
                    </div>
                  </template>
                </section>
              </div>
            </template>
          </div>
          <div class="col-12 mt-4">
            <div
              class="col-12 mt-4"
              v-show="hasMorePages && noClientSelected === false"
            >
              <div class="btn-container" style="text-align: center">
                <button
                  class="btn-primary btn"
                  @click="currentPage = currentPage + 1"
                >
                  Load more
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DateTimePicker from 'vue-ctk-date-time-picker';
import OrderService from '../../services/orders';
import OrderPerimeters from '../../configs/Perimeters/orders';
import {refreshPageMixin} from '../../mixins/refreshPage';
import {parse, addDays, format} from 'date-fns';
import Navigation from '../../configs/Perimeters/navigation';
import {mapGetters} from 'vuex';
import AgencyListDropdown, {
  AgencyListAllOption,
} from '../Agencies/AgencyListDropdown.vue';
import PackageListDropdown, {
  PackageListAllOption,
} from '../Packages/PackageListDropdown.vue';
import ClientListDropdown, {
  ClientListAllOption,
} from '../Clients/ClientListDropdown.vue';
import OrderStatusDropdown, {
  OrderStatusListAllOption,
} from '../Orders/OrderStatusDropdown.vue';
import OrderInvoiceDropdown from '../Orders/OrderInvoiceDropdown.vue';
import OrderTypeDropdown, {
  OrderTypeAllOption,
} from '../Orders/OrderTypeDropdown.vue';
import {FilterBuilder} from '../../helpers/FilterBuilder';
import {OrderDropdownFilterSelectedHelper} from '../../helpers/OrderDropdownFilterSelectedHelper';
import AppActionNeeded from '../AppComponents/AppActionNeeded.vue';
import {StringToCapitalizedCase} from '../../helpers/StringToCapitalizedCase';

export default {
  mixins: [refreshPageMixin],
  perimeters: [OrderPerimeters],
  components: {
    DateTimePicker,
    ClientListDropdown,
    AppActionNeeded,
  },
  data() {
    return {
      selectedClient: null,
      selectedDates: {
        start: null,
        end: null,
      },
      searchText: '',
      searchTimeout: null,
      orders: [],
      currentCursor: 0,
      nextCursor: 0,
      hasMorePages: false,
      noResults: false,
      filterBuilder: new FilterBuilder(),
      activeRoute: '',
      currentPage: 1,
      totalRows: 0,
    };
  },
  methods: {
    getOrders() {
      OrderService.getOrders(
        this.filterBuilder.get(), // Add filter
        {
          field: 'campaign.createdAt',
          order: 'DESC',
        }, // Sort
        0,
        this.currentPage,
        10
      ).then((response) => {
        this.noResults = response.data.length === 0 && this.orders.length === 0;
        const normalizedData = response.data.map(function(order) {
          let endDate = 'N/A';

          if (order.package && order.package.type) {
            let duration = null;
            switch (order.package.type) {
              case 'property':
              case 'agent extend':
                duration = order.package.propertyDuration;
                break;
              case 'agent':
                duration = order.package.agentDuration;
                break;
              case 'office':
                duration = order.package.officeDuration;
                break;
              default:
                duration = null;
                break;
            }

            if (duration) {
              if (order.campaign.startDate) {
                const parsedDate = parse(order.campaign.startDate);
                const newDate = addDays(parsedDate, duration);
                endDate = format(newDate, 'DD MMM YYYY');
              } else {
                endDate = null;
              }
            }
          }

          return {
            ...order,
            campaign: {
              ...order.campaign,
              endDate,
            },
          };
        });

        this.orders =
          this.currentPage === 1
            ? normalizedData
            : [...this.orders, ...normalizedData];
        const hasNext = response.meta.cursor.hasOwnProperty('next');
        this.hasMorePages = hasNext;
        if (hasNext) {
          this.nextCursor = response.meta.cursor.next.cursor;
        }

        this.getTotalRows();
      });
    },
    clearFilters() {
      this.selectedClient = null;
      this.orders = [];
      this.selectedDates = {
        start: null,
        end: null,
      };
      this.searchText = '';
    },
    handleClientSelected(value) {
      this.selectedClient = value;
    },
    handleClientRemoved(value) {
      this.clearFilters();
    },
    hasGst(order) {
      return order.agency && order.agency.includeGst;
    },
    exportCSV() {
      var today = new Date();
      var date =
        today.getFullYear() +
        '-' +
        (today.getMonth() + 1) +
        '-' +
        today.getDate();
      OrderService.exportToCSV(this.filterBuilder.get(), {
        field: 'campaign.createdAt',
        order: 'DESC',
      })
        .then((blob) => {
          let url = window.URL.createObjectURL(new Blob([blob]));
          let link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', `Orders Export - ${date}.csv`);
          document.body.appendChild(link);
          link.click();
        })
        .catch((error) => {
          console.log(error);
        });
    },
    getTotalRows() {
      OrderService.getTotalRows(this.filterBuilder.get()).then((totalRows) => {
        this.totalRows = totalRows.data;
      });
    },
    goToDashboard(order) {
      const isPropertyCampaign =
        order.campaignType == 'property' ||
        order.campaignType == 'property extend' ||
        order.campaignType == 'property just sold';
      const urlCampaignPathSegment = isPropertyCampaign
        ? 'property-campaigns'
        : 'agent-campaigns';
      const urlPath = `/office/${
        order.agency.slug.name
      }/${urlCampaignPathSegment}/${order.campaign.id}`;

      this.$router.push(urlPath);
    },
    setActive(name) {
      this.activeRoute = name;
    },
    goToOrders() {
      this.setActive('orders');
    },
    handlePreselectedClient() {
      const isUserAdmin =
        Navigation.isClientAdmin() || Navigation.isAgencyAdmin();

      if (isUserAdmin === false) return;

      const user = this.$store.getters.getUser;

      const formattedClientName = StringToCapitalizedCase(user.client);

      this.selectedClient = {
        id: user.clientId,
        title: formattedClientName,
      };
    },
  },
  computed: {
    ...mapGetters(['getOrdersFilter']),
    noClientSelected() {
      return null === this.selectedClient;
    },
    /**
     * A wrapper around our filters so that we can have the ability to watch
     * all of these in a single watcher method rather than declaring one
     * watcher for each value.
     *
     * This computed value will will have keys that correspond to the filters
     * the API is expected.
     */
    watchedFilterBuilderValues() {
      return {
        client: null === this.selectedClient ? [] : [this.selectedClient.id],
        dateFrom: this.selectedDates.start,
        dateTo: this.selectedDates.end,
      };
    },
  },
  watch: {
    watchedFilterBuilderValues: {
      handler: function(value) {
        // Reset orders when filter has changed
        this.orders = [];
        this.currentPage = 1;
        this.hasMorePages = false;
        this.noResults = false;
        // Clone incoming object
        const filters = Object.assign({}, value);
        const keys = Object.keys(filters);

        this.filterBuilder.updateFilter('order', 'latest');

        keys.forEach((key) => {
          if (Array.isArray(filters[key])) {
            let filteredArray = filters[key].filter((val) => val); // Remove empty values
            if (filteredArray.length === 0) {
              this.filterBuilder.removeFilter(key);
            } else {
              this.filterBuilder.updateFilter(key, filteredArray);
            }
          } else {
            if (!filters[key]) {
              this.filterBuilder.removeFilter(key);
            } else {
              this.filterBuilder.updateFilter(key, filters[key]);
            }
          }
        });

        if (null === this.selectedClient) return;

        this.getOrders();
      },
      deep: true,
    },
    currentPage: {
      handler(value) {
        if (1 === value) return;
        if (null === this.selectedClient) return;

        this.getOrders();
      },
    },
    searchText: {
      handler(value) {
        clearTimeout(this.searchTimeout);
        this.currentPage = 1;
        this.hasMorePages = false;
        this.noResults = false;

        if (!value) {
          this.filterBuilder.removeFilter('searchText');
        } else {
          this.filterBuilder.addFilter('searchText', value);
        }

        if (null === this.selectedClient) return;

        this.searchTimeout = setTimeout(() => {
          this.getOrders();
        }, 1000);
      },
    },
  },
  mounted() {
    this.handlePreselectedClient();
  },
};
</script>

<style lang="css" scoped>
.badge-draft {
  background-color: #ffb30f;
  color: black;
}
</style>

